module.exports = __webpack_public_path__ + "static/img/r_003.d8597db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_003.jpg
// module id = y0me
// module chunks = 1